import Keycloak from 'keycloak-js';

// keycloak-js 인스턴스의 authServerUrl·clientId 는 init() 안에서 채워진다
// (keycloak.js 의 loadConfig). 이 앱은 init() 을 호출하지 않으므로 인스턴스에서
// 그 값을 읽으면 undefined 다. 설정을 여기서 따로 내보내 단일 출처로 쓴다.
export const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL || 'https://demo.qureka.io', // Keycloak 인증 서버 URL
  realm: 'jhipster', // 사용 중인 Realm 이름
  clientId: 'qurea-portal', // Apache Answer에 설정한 클라이언트 ID
};

const keycloak = new Keycloak(keycloakConfig);

// Keycloak SSO 세션까지 끊는 로그아웃 URL.
// Answer 세션만 지우면 Keycloak 세션이 남아, 로그인 버튼을 누르는 순간 화면 없이
// 재로그인된다 — 사용자에게는 로그아웃이 안 된 것으로 보인다.
// id_token_hint 는 Answer 가 서버측에 보관해 프런트에 없으므로
// client_id + post_logout_redirect_uri 조합을 쓴다 (Keycloak 18+ 는 client_id 필수).
export function ssoLogoutUrl(returnUrl?: string) {
  const base = keycloakConfig.url.replace(/\/$/, '');
  const q = new URLSearchParams({
    client_id: keycloakConfig.clientId,
    post_logout_redirect_uri:
      returnUrl ??
      `${window.location.origin}${process.env.REACT_APP_BASE_URL || '/'}`,
  });
  return `${base}/realms/${keycloakConfig.realm}/protocol/openid-connect/logout?${q}`;
}

export default keycloak;
